import {
  BarChart3,
  Bot,
  Database,
  Globe,
  LayoutDashboard,
  LucideIcon,
  MessageCircle,
  Shield,
  Sparkles,
  Workflow,
  Boxes,
  Cpu,
  FileBarChart,
  HeartPulse,
  KeyRound,
} from 'lucide-react';

export interface CatalogIconOption {
  name: string;
  icon: LucideIcon;
  label: string;
}

export const CATALOG_ICON_OPTIONS: CatalogIconOption[] = [
  { name: 'Bot', icon: Bot, label: 'Bot' },
  { name: 'Globe', icon: Globe, label: 'Globe' },
  { name: 'LayoutDashboard', icon: LayoutDashboard, label: 'Dashboard' },
  { name: 'Shield', icon: Shield, label: 'Shield' },
  { name: 'BarChart3', icon: BarChart3, label: 'Analytics' },
  { name: 'Database', icon: Database, label: 'Database' },
  { name: 'MessageCircle', icon: MessageCircle, label: 'Chat' },
  { name: 'Sparkles', icon: Sparkles, label: 'Sparkles' },
  { name: 'Workflow', icon: Workflow, label: 'Workflow' },
  { name: 'Boxes', icon: Boxes, label: 'Boxes' },
  { name: 'Cpu', icon: Cpu, label: 'CPU' },
  { name: 'FileBarChart', icon: FileBarChart, label: 'Reports' },
  { name: 'HeartPulse', icon: HeartPulse, label: 'Health' },
  { name: 'KeyRound', icon: KeyRound, label: 'Keys' },
];

export const CATALOG_ICON_MAP: Record<string, LucideIcon> = Object.fromEntries(
  CATALOG_ICON_OPTIONS.map((opt) => [opt.name, opt.icon])
);

export const CATALOG_ICON_COLORS: { value: string; className: string }[] = [
  { value: 'indigo', className: 'bg-indigo-500' },
  { value: 'violet', className: 'bg-violet-500' },
  { value: 'cyan', className: 'bg-cyan-500' },
  { value: 'emerald', className: 'bg-emerald-500' },
  { value: 'amber', className: 'bg-amber-500' },
  { value: 'rose', className: 'bg-rose-500' },
  { value: 'sky', className: 'bg-sky-500' },
  { value: 'fuchsia', className: 'bg-fuchsia-500' },
];

export function getCatalogIcon(name: string): LucideIcon {
  return CATALOG_ICON_MAP[name] || Boxes;
}

export function getCatalogIconColorClass(color: string): string {
  return CATALOG_ICON_COLORS.find((c) => c.value === color)?.className || 'bg-indigo-500';
}
